export default {
    hasParticles: true,
    particles: {
        icons: ['mdi-leaf', 'mdi-leaf-maple'],
        colors: ['light-green', 'yellow', 'amber', 'orange', 'orange-red', 'brown', 'cherry'],
        opacity: [20, 70],
        size: [20, 80],
        time: [4, 12],
        amount: 4,
        rotate: true
    },
    light: {
        primary: '#74401B',
        secondary: '#424242',
        accent: '#503D30',
    },
    dark: {
        primary: '#74401B',
        secondary: '#424242',
        accent: '#503D30',
    }
}
